/**
 *
 * @param {string} name
 * @returns
 */

const url = `app`;

export const LOAD_PURCHASE_INVOICE = `${url}/LOAD_PURCHASE_INVOICE`;
export const LOAD_PURCHASE_INVOICE_SUCCESS = `${url}/LOAD_PURCHASE_INVOICE_SUCCESS`;
export const LOAD_PURCHASE_INVOICE_ERROR = `${url}/LOAD_PURCHASE_INVOICE_ERROR`;

export const LOAD_PURCHASE_PRINT_RECEIPT = `${url}/LOAD_PURCHASE_PRINT_RECEIPT`;
export const LOAD_PURCHASE_PRINT_RECEIPT_SUCCESS = `${url}/LOAD_PURCHASE_PRINT_RECEIPT_SUCCESS`;
export const LOAD_PURCHASE_PRINT_RECEIPT_ERROR = `${url}/LOAD_PURCHASE_PRINT_RECEIPT_ERROR`;

export const LOAD_PURCHASE_BARCODE = `${url}/LOAD_PURCHASE_BARCODE`;
export const LOAD_PURCHASE_BARCODE_SUCCESS = `${url}/LOAD_PURCHASE_BARCODE_SUCCESS`;
export const LOAD_PURCHASE_BARCODE_ERROR = `${url}/LOAD_PURCHASE_BARCODE_ERROR`;

export const LOAD_PURCHASE_INVOICE_DASHBOARD_TRANSACTION = `${url}/LOAD_PURCHASE_INVOICE_DASHBOARD_TRANSACTION`;
export const LOAD_PURCHASE_INVOICE_DASHBOARD_TRANSACTION_SUCCESS = `${url}/LOAD_PURCHASE_INVOICE_DASHBOARD_TRANSACTION_SUCCESS`;
export const LOAD_PURCHASE_INVOICE_DASHBOARD_TRANSACTION_ERROR = `${url}/LOAD_PURCHASE_INVOICE_DASHBOARD_TRANSACTION_ERROR`;

export const LOAD_PURCHASE_TOTAL = `${url}/LOAD_PURCHASE_TOTAL`;
export const LOAD_PURCHASE_TOTAL_SUCCESS = `${url}/LOAD_PURCHASE_TOTAL_SUCCESS`;
export const LOAD_PURCHASE_TOTAL_ERROR = `${url}/LOAD_PURCHASE_TOTAL_ERROR`;

export const LOAD_TOTAL_PAID = `${url}/LOAD_TOTAL_PAID`;
export const LOAD_TOTAL_PAID_SUCCESS = `${url}/LOAD_TOTAL_PAID_SUCCESS`;
export const LOAD_TOTAL_PAID_ERROR = `${url}/LOAD_TOTAL_PAID_ERROR`;
export const LOAD_TOTAL_UNPAID = `${url}/LOAD_TOTAL_UNPAID`;
export const LOAD_TOTAL_UNPAID_SUCCESS = `${url}/LOAD_TOTAL_UNPAID_SUCCESS`;
export const LOAD_TOTAL_UNPAID_ERROR = `${url}/LOAD_TOTAL_UNPAID_ERROR`;

export const CREATE_PURCHASE_INVOICE = `${url}/CREATE_PURCHASE_INVOICE`;
export const CREATE_PURCHASE_INVOICE_SUCCESS = `${url}/CREATE_PURCHASE_INVOICE_SUCCESS`;
export const CREATE_PURCHASE_INVOICE_ERROR = `${url}/CREATE_PURCHASE_INVOICE_ERROR`;

//category
export const LOAD_PURCHASE_INVOICE_CATEGORY = `${url}/LOAD_PURCHASE_INVOICE_CATEGORY`;
export const LOAD_PURCHASE_INVOICE_CATEGORY_SUCCESS = `${url}/LOAD_PURCHASE_INVOICE_CATEGORY_SUCCESS`;
export const LOAD_PURCHASE_INVOICE_CATEGORY_ERROR = `${url}/LOAD_PURCHASE_INVOICE_CATEGORY_ERROR`;

export const CREATE_PURCHASE_INVOICE_PARTIES_CATEGORY = `${url}/CREATE_PURCHASE_INVOICE_PARTIES_CATEGORY`;
export const CREATE_PURCHASE_INVOICE_PARTIES_CATEGORY_SUCCESS = `${url}/CREATE_PURCHASE_INVOICE_PARTIES_CATEGORY_SUCCESS`;
export const CREATE_PURCHASE_INVOICE_PARTIES_CATEGORY_ERROR = `${url}/CREATE_PURCHASE_INVOICE_PARTIES_CATEGORY_ERROR`;

export const UPDATE_PURCHASE_INVOICE = `${url}/UPDATE_PURCHASE_INVOICE`;
export const UPDATE_PURCHASE_INVOICE_SUCCESS = `${url}/UPDATE_PURCHASE_INVOICE_SUCCESS`;
export const UPDATE_PURCHASE_INVOICE_ERROR = `${url}/UPDATE_PURCHASE_INVOICE_ERROR`;

export const DELETE_PURCHASE_INVOICE = `${url}/DELETE_PURCHASE_INVOICE`;
export const DELETE_PURCHASE_INVOICE_SUCCESS = `${url}/DELETE_PURCHASE_INVOICE_SUCCESS`;
export const DELETE_PURCHASE_INVOICE_ERROR = `${url}/DELETE_PURCHASE_INVOICE_ERROR`;

export const LOAD_PURCHASE_INVOICE_RECORDS_META_DATA = `${url}/LOAD_PURCHASE_INVOICE_RECORDS_META_DATA`;
export const LOAD_PURCHASE_INVOICE_RECORDS_META_DATA_SUCCESS = `${url}/LOAD_PURCHASE_INVOICE_RECORDS_META_DATA_SUCCESS`;
export const LOAD_PURCHASE_INVOICE_RECORDS_META_DATA_ERROR = `${url}/LOAD_PURCHASE_INVOICE_RECORDS_META_DATA_ERROR`;
export const LOAD_RECORDS_VALID_CACHE = `${url}/LOAD_RECORDS_VALID_CACHE`;

export const LOAD_PARTIES_TRANSACTION = `${url}/LOAD_PARTIES_TRANSACTION`;
export const LOAD_PARTIES_TRANSACTION_SUCCESS = `${url}/LOAD_PARTIES_TRANSACTION_SUCCESS`;
export const LOAD_PARTIES_TRANSACTION_ERROR = `${url}/LOAD_PARTIES_TRANSACTION_ERROR`;

// address update
export const LOAD_PURCHASE_PARTY_VENDOR_ADDRESS = `${url}/LOAD_PURCHASE_PARTY_VENDOR_ADDRESS`;
export const LOAD_PURCHASE_PARTY_VENDOR_ADDRESS_SUCCESS = `${url}/LOAD_PURCHASE_PARTY_VENDOR_ADDRESS_SUCCESS`;
export const LOAD_PURCHASE_PARTY_VENDOR_ADDRESS_ERROR = `${url}/LOAD_PURCHASE_PARTY_VENDOR_ADDRESS_ERROR`;

export const CREATE_PURCHASE_PARTY_VENDOR_ADDRESS = `${url}/CREATE_PURCHASE_PARTY_VENDOR_ADDRESS`;
export const CREATE_PURCHASE_PARTY_VENDOR_ADDRESS_SUCCESS = `${url}/CREATE_PURCHASE_PARTY_VENDOR_ADDRESS_SUCCESS`;
export const CREATE_PURCHASE_PARTY_VENDOR_ADDRESS_ERROR = `${url}/CREATE_PURCHASE_PARTY_VENDOR_ADDRESS_ERROR`;

// purchase import & barcode
export const LOAD_PURCHASE_IMPORT_RAM_LIST = `${url}/LOAD_PURCHASE_IMPORT_RAM_LIST`;
export const LOAD_PURCHASE_IMPORT_RAM_LIST_SUCCESS = `${url}/LOAD_PURCHASE_IMPORT_RAM_LIST_SUCCESS`;
export const LOAD_PURCHASE_IMPORT_RAM_LIST_ERROR = `${url}/LOAD_PURCHASE_IMPORT_RAM_LIST_ERROR`;

export const LOAD_PURCHASE_BARCODE_UPDATE_LIST = `${url}/LOAD_PURCHASE_BARCODE_UPDATE_LIST`;
export const LOAD_PURCHASE_BARCODE_UPDATE_LIST_SUCCESS = `${url}/LOAD_PURCHASE_BARCODE_UPDATE_LIST_SUCCESS`;
export const LOAD_PURCHASE_BARCODE_UPDATE_LIST_ERROR = `${url}/LOAD_PURCHASE_BARCODE_UPDATE_LIST_ERROR`;

export const LOAD_SCAN_BARCODE_LIST = `${url}/LOAD_SCAN_BARCODE_LIST`;
export const LOAD_SCAN_BARCODE_LIST_SUCCESS = `${url}/LOAD_SCAN_BARCODE_LIST_SUCCESS`;
export const LOAD_SCAN_BARCODE_LIST_ERROR = `${url}/LOAD_SCAN_BARCODE_LIST_ERROR`;

const constants = {
  LOAD_PURCHASE_INVOICE,
  LOAD_PURCHASE_INVOICE_SUCCESS,
  LOAD_PURCHASE_INVOICE_ERROR,

  LOAD_PURCHASE_PRINT_RECEIPT,
  LOAD_PURCHASE_PRINT_RECEIPT_SUCCESS,
  LOAD_PURCHASE_PRINT_RECEIPT_ERROR,

  LOAD_PURCHASE_IMPORT_RAM_LIST,
  LOAD_PURCHASE_IMPORT_RAM_LIST_SUCCESS,
  LOAD_PURCHASE_IMPORT_RAM_LIST_ERROR,

  LOAD_PURCHASE_BARCODE_UPDATE_LIST,
  LOAD_PURCHASE_BARCODE_UPDATE_LIST_SUCCESS,
  LOAD_PURCHASE_BARCODE_UPDATE_LIST_ERROR,

  LOAD_SCAN_BARCODE_LIST,
  LOAD_SCAN_BARCODE_LIST_SUCCESS,
  LOAD_SCAN_BARCODE_LIST_ERROR,

  LOAD_PURCHASE_BARCODE,
  LOAD_PURCHASE_BARCODE_SUCCESS,
  LOAD_PURCHASE_BARCODE_ERROR,

  LOAD_PURCHASE_INVOICE_DASHBOARD_TRANSACTION,
  LOAD_PURCHASE_INVOICE_DASHBOARD_TRANSACTION_SUCCESS,
  LOAD_PURCHASE_INVOICE_DASHBOARD_TRANSACTION_ERROR,
  LOAD_PURCHASE_TOTAL,
  LOAD_PURCHASE_TOTAL_SUCCESS,
  LOAD_PURCHASE_TOTAL_ERROR,
  LOAD_TOTAL_PAID,
  LOAD_TOTAL_PAID_SUCCESS,
  LOAD_TOTAL_PAID_ERROR,
  LOAD_TOTAL_UNPAID,
  LOAD_TOTAL_UNPAID_SUCCESS,
  LOAD_TOTAL_UNPAID_ERROR,
  LOAD_PURCHASE_PARTY_VENDOR_ADDRESS,
  LOAD_PURCHASE_PARTY_VENDOR_ADDRESS_SUCCESS,
  LOAD_PURCHASE_PARTY_VENDOR_ADDRESS_ERROR,
  CREATE_PURCHASE_PARTY_VENDOR_ADDRESS,
  CREATE_PURCHASE_PARTY_VENDOR_ADDRESS_SUCCESS,
  CREATE_PURCHASE_PARTY_VENDOR_ADDRESS_ERROR,

  LOAD_PARTIES_TRANSACTION,
  LOAD_PARTIES_TRANSACTION_SUCCESS,
  LOAD_PARTIES_TRANSACTION_ERROR,

  LOAD_PURCHASE_INVOICE_CATEGORY,
  LOAD_PURCHASE_INVOICE_CATEGORY_SUCCESS,
  LOAD_PURCHASE_INVOICE_CATEGORY_ERROR,

  CREATE_PURCHASE_INVOICE_PARTIES_CATEGORY,
  CREATE_PURCHASE_INVOICE_PARTIES_CATEGORY_SUCCESS,
  CREATE_PURCHASE_INVOICE_PARTIES_CATEGORY_ERROR,

  CREATE_PURCHASE_INVOICE,
  CREATE_PURCHASE_INVOICE_SUCCESS,
  CREATE_PURCHASE_INVOICE_ERROR,

  UPDATE_PURCHASE_INVOICE,
  UPDATE_PURCHASE_INVOICE_SUCCESS,
  UPDATE_PURCHASE_INVOICE_ERROR,

  DELETE_PURCHASE_INVOICE,
  DELETE_PURCHASE_INVOICE_SUCCESS,
  DELETE_PURCHASE_INVOICE_ERROR,

  LOAD_RECORDS_VALID_CACHE,

  LOAD_PURCHASE_INVOICE_RECORDS_META_DATA,
  LOAD_PURCHASE_INVOICE_RECORDS_META_DATA_SUCCESS,
  LOAD_PURCHASE_INVOICE_RECORDS_META_DATA_ERROR,
};

export default constants;
